import type { SpecRow } from '../../types'

interface SpecTableProps {
  rows: SpecRow[]
  caption?: string
}

export function SpecTable({ rows, caption }: SpecTableProps) {
  return (
    <div className="overflow-x-auto">
      <table className="w-full border-collapse text-sm">
        {caption && <caption className="sr-only">{caption}</caption>}
        <tbody>
          {rows.map((r, i) => (
            <tr key={r.parameter + i} className="border-b border-sand-200 last:border-0">
              <th scope="row" className="w-1/2 py-3 pr-4 text-left align-top font-medium text-ink-700">
                {r.parameter}
              </th>
              <td className="py-3 align-top tabular-nums text-ink-500">{r.value}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
